<template>
    <div class="pin-settings" @click="$emit('close')">
        <div class="pin-settings" v-if="deleting" @click.stop>
            <div class="pin-settings-container choise" @click.stop>
                <h3 class="pin-settings__title">Вы действительно хотите удалить {{settings.type === 'pin' ? 'пост' : 'комментарий'}}?</h3>
                <div class="pin-settings-buttons">
                    <div class="button" @click="deleteEl()">
                        <p v-if="!loading">Да</p>
                    </div>
                    <div class="button" @click="deleting = false">Нет</div>
                </div>
            </div>
        </div>
        <!-- <div class="pin-settings-container choise" @click.stop v-if="blocking">
            <h3 class="pin-settings__title">Вы действительно хотите заблокировать этого пользователя?</h3>
            <div class="pin-settings-buttons">
                <div class="button" @click="blockUser()">
                    <p v-if="!loading">Да</p>
                </div>
                <div class="button">Нет</div>
            </div>
        </div> -->
        <div class="pin-settings-container" @click.stop v-else-if="settings.type == 'pin'">
            <!-- <div class="pin-settings-item">
                <p>Поделиться</p>
            </div> -->
            <div class="pin-settings-item" @click="copyLink()">
                <p>Скопировать ссылку</p>
            </div>
            <!-- <div class="pin-settings-item red">
                <p>Отменить подписку</p>
            </div> -->
            <!-- <div class="pin-settings-item" v-if="itsYou" @click="$emit('editPin', settings)">
                <p>Редактировать</p>
            </div> -->
            <div class="pin-settings-item" v-if="!itsYou" @click="$emit('unwantedPin', settings)">
                <p>Не показывать</p>
            </div>
            <div class="pin-settings-item red" v-if="!itsYou" @click="complain = true">
                <p>Пожаловаться</p>
            </div>
            <div class="pin-settings-item red" v-if="itsYou" @click="deleting = true">
                <p>Удалить</p>
            </div>
        </div>
        <div class="pin-settings-container" @click.stop v-else>
            <div class="pin-settings-item red" v-if="!itsYou" @click="complain = true">
                <p>Пожаловаться</p>
            </div>
            <div class="pin-settings-item" v-if="itsYou" @click="$emit('editComment', settings)">
                <p>Редактировать</p>
            </div>
            <div class="pin-settings-item red" v-if="itsYou" @click="deleting = true">
                <p>Удалить</p>
            </div>
        </div>
        <Complain 
            v-if='complain'
            :settings="settings"
            @click="complain = false"
            @close="complain = false" />
    </div>
</template>
<script>

export default {
    name: 'PinSettings',
    data () {
        return {
            loading: false,
            deleting: false,
            complain: false,
        }
    },
    props: {
        settings: {
            type: Object,
            required: true
        }
    },
    components: {
        Complain: () => import('../Lenta/Complain.vue')
    },
    computed: {
        itsYou() {
            return this.getUser.id === this.settings[this.settings.type].author_id
        },
        getUser() {
            return this.$store.getters.getAuthUser
        }
    },
    methods: {
        async deleteEl() {
            if (this.settings.type === 'pin') {
                this.loading = true
                await this.$store.dispatch('deletePin', {id: this.settings.pin.id})
                this.loading = false
                this.$store.dispatch('addNotification', {message: `Ваш пост «‎${this.cutString(this.settings.pin.content, 30)} удален!»`})
                this.$emit('close')
            } else if (this.settings.type === 'comment') {
                this.loading = true
                await this.$store.dispatch('deletePinComment', this.settings.comment)
                this.loading = false
                this.$emit('close')
                this.$store.dispatch('addNotification', {message: `Ваш комментарий «‎${this.cutString(this.settings.comment.content, 30)} удален!»`})
            }
        },
        copyLink () {
            const el = document.createElement('textarea');  
            el.value = 'https://wiildwood.online/lenta/' + this.settings.pin.id;
            el.setAttribute('readonly', '');                
            el.style.position = 'absolute';                     
            el.style.left = '-9999px';                      
            document.body.appendChild(el);                  
            const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
            el.select();                                    
            document.execCommand('copy');                   
            document.body.removeChild(el);                  
            if (selected) {                                 
            document.getSelection().removeAllRanges();    
            document.getSelection().addRange(selected);   
            }
            this.$store.dispatch('addNotification', {message: 'Ссылка на пост скопирована'})
            this.$emit('close')
        },
        cutString (val, length) {
            if (val) {
                val = val.length > length ? val.slice(0, length).concat('...') : val;
            }
            return val
        }
    }
}
</script>
<style lang="stylus" scoped>
    .pin-settings
        position fixed
        left 0
        top 0
        right 0
        bottom 0
        display flex
        align-items center
        justify-content center
        z-index 5
        padding 20px

        &-container
            width 450px
            background-color white
            border-radius 20px
            box-shadow 0px 0px 30px rgba(162, 162, 162, 0.25)
            &.choise
                padding 40px
        
        &__title
            text-align center
            font-size 22px
            font-weight 500
            line-height 28px

        &-buttons
            display flex
            justify-content center
            margin-top 20px
            .button
                margin 0 15px

        &-item
            display flex
            justify-content center
            padding 15px 0
            font-size 16px
            font-weight 500
            border-bottom 1px solid #f0f0f0
            cursor pointer
            &:last-child
                border-bottom 0
            &.red
                color red
</style>